/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Odd_Agent_Tapir_LearnInputs */

const fr_odd_agent_tapir_learn = /** @type {(inputs: Odd_Agent_Tapir_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Légende des status`)
};

/**

* @param {Odd_Agent_Tapir_LearnInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const odd_agent_tapir_learn = /** @type {((inputs?: Odd_Agent_Tapir_LearnInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Odd_Agent_Tapir_LearnInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_odd_agent_tapir_learn(inputs)
});